/*
======================================================
BYMOQA State Manager
======================================================
*/

window.initBymoqaState = function(app){

    app.state = {

        current : "idle",

        change(newState){

            this.current = newState;

        }

    };

}